var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"line-wrapper"},[_c('div',{ref:"myLine",staticClass:"pie"})])
}
var staticRenderFns = []

export { render, staticRenderFns }